__turbopack_context__.v({
  "body": "index-module-scss-module__BQWtxa__body",
  "buttonIcon": "index-module-scss-module__BQWtxa__buttonIcon",
  "buttonIcon__selected": "index-module-scss-module__BQWtxa__buttonIcon__selected",
  "jello-vertical": "index-module-scss-module__BQWtxa__jello-vertical",
  "link": "index-module-scss-module__BQWtxa__link",
  "linkPage": "index-module-scss-module__BQWtxa__linkPage",
  "linkPageText": "index-module-scss-module__BQWtxa__linkPageText",
  "linkPageText__selected": "index-module-scss-module__BQWtxa__linkPageText__selected",
  "linkPage__selected": "index-module-scss-module__BQWtxa__linkPage__selected",
  "linkSupport": "index-module-scss-module__BQWtxa__linkSupport",
  "linkText": "index-module-scss-module__BQWtxa__linkText",
  "link__open": "index-module-scss-module__BQWtxa__link__open",
  "link__selected": "index-module-scss-module__BQWtxa__link__selected",
  "logo": "index-module-scss-module__BQWtxa__logo",
  "logo__open": "index-module-scss-module__BQWtxa__logo__open",
  "root": "index-module-scss-module__BQWtxa__root",
  "root__open": "index-module-scss-module__BQWtxa__root__open",
  "toggleArrow": "index-module-scss-module__BQWtxa__toggleArrow",
  "toggleArrow__open": "index-module-scss-module__BQWtxa__toggleArrow__open",
  "wrapper": "index-module-scss-module__BQWtxa__wrapper",
  "wrapper__open": "index-module-scss-module__BQWtxa__wrapper__open",
  "wrapper__withTopBanner": "index-module-scss-module__BQWtxa__wrapper__withTopBanner",
});
